import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { clientMutation, clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from "Core/defaultValues";
import { ExceptionManager, LogManagerConsole } from 'Core/logManager';

import { resetALL } from 'Redux/actions';

//STATE INITIAL
const INIT_STATE = {
  open: false,
  loading: false,
  error: null,
  data: null,
  items: []
};

const route = 'modules/maintenance/views/main/components/emissionCheckTab/modals/save/redux/slice';

export const emissionCheckSaveOpen = createAsyncThunk('emissionCheck/save/open', async (params, { rejectWithValue, dispatch, getState }) => {
  try {
    LogManagerConsole("EmissionCheck", "emissionCheckSaveOpen", params);
    const response = await clientQuery(
      `
      query getAvailableCarbUnits ($limit: Int, $offset: Int) {
        data: getAvailableCarbUnits (limit: $limit, offset: $offset) {
          items {
            id
            label
            vin
          }
          total
        }
      }
      `,
      {
        limit: 100,
        offset: 0
      },
      endpoints.GRAPHQL_GENERAL_V2
    );
    LogManagerConsole("EmissionCheck", "emissionCheckSaveOpen unitsList", response);
    return { data: params?.data, items: response?.data };
  } catch (exc) {
    ExceptionManager(exc, route, 'emissionCheckSaveOpen');
    return rejectWithValue(exc)
  }
});

export const emissionCheckSave = createAsyncThunk('emissionCheck/save', async (data, { rejectWithValue, dispatch, getState }) => {
  try {
    LogManagerConsole("EmissionCheck", "emissionCheckSave", data);

    let response
    if (data?.id) {
      response = await clientMutation(
        `
          mutation updateCarbSchedule ($id: Int!, $unitId: Int!, $nextDeadline: String) {
            updateCarbSchedule (id: $id, unitId: $unitId, nextDeadline: $nextDeadline) {
              id
            }
          }
        `,
        {
          id: data.id,
          unitId: data.unitId.id || data.unitId,
          nextDeadline: data.nextDeadline
        },
        endpoints.GRAPHQL_GENERAL_V2
      );
    }
    else {
      response = await clientMutation(
        `
          mutation createCarbSchedule ($unitId: Int!, $nextDeadline: String!) {
            createCarbSchedule (unitId: $unitId, nextDeadline: $nextDeadline) {
              id
            }
          }
        `,
        {
          unitId: data.unitId.id,
          nextDeadline: data.nextDeadline
        },
        endpoints.GRAPHQL_GENERAL_V2
      );
    }

    LogManagerConsole("EmissionCheck", "emissionCheckSave", response);
    return { id: response.id };
  } catch (exc) {
    ExceptionManager(exc, route, 'emissionCheckSave');
    return rejectWithValue(exc)
  }
});

//emissionCheckSaveRedux
const emissionCheckSaveRedux = createSlice({
  name: 'emissionCheck/save',
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : INIT_STATE
    },
    closeModal(state, action) {
      state.open = false
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //emissionCheckSaveOpen
    builder.addCase(emissionCheckSaveOpen.pending, (state, action) => {
      state.loading = true
      state.data = {}
    });
    builder.addCase(emissionCheckSaveOpen.fulfilled, (state, action) => {
      state.loading = false;
      state.open = true
      state.data = action.payload?.data
      state.items = action.payload?.items
    });
    builder.addCase(emissionCheckSaveOpen.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload
    });

    //emissionCheckSave
    builder.addCase(emissionCheckSave.pending, (state, action) => {
      state.loading = true
    });
    builder.addCase(emissionCheckSave.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload
    });
    builder.addCase(emissionCheckSave.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload
    });
  },
})

// Extract and export the action creators object and the reducer
export const { actions, reducer } = emissionCheckSaveRedux;

// Extract and export each action creator by name
export const { reset, closeModal } = actions;

//Simple async action

// Export the reducer, either as a default or named export
export default reducer;